import {useMutation, UseMutationResult} from '@tanstack/react-query';
import {useLocale} from 'state/locale';
import Api from 'types/api';
import {LongTask} from 'types/long-task';
import {request} from 'utils/request';

export type LongTaskResponseErrorResponse = Api.Response.Failure<'value'>;

export type LongTaskResponseSuccessResponse = Api.Response.Success<LongTask>;

export const useGetLongTaskProgress = (): UseMutationResult<
    LongTaskResponseSuccessResponse,
    LongTaskResponseErrorResponse,
    string
> => {
    const locale = useLocale();

    return useMutation({
        mutationFn: (progressUrl) =>
            request({locale, method: 'GET', uri: progressUrl}),
    });
};

export default useGetLongTaskProgress;
